import React, { useState, useEffect } from 'react';
import { Button, MultiSelect, } from 'carbon-components-react';
import { boolean, select, text, object } from '@storybook/addon-knobs';
import axios from "axios";
import i18n from "../../i18n";
import * as Constants from '../../requests/URLConstants'
import callPostApi from "../../requests/PostRequests";
import callGetApi from "../../requests/GetRequests";
import * as workspaces from '../../config/WorkspaceConstants'

require("./HomeScreen.scss");

const sizes = {
    'Extra large size (xl)': 'xl',
    'Default size': undefined,
    'Small size (sm)': 'sm',
};
const types = {
    'Default (default)': 'default',
    'Inline (inline)': 'inline',
};
const directions = {
    'Bottom (default)': 'bottom',
    'Top ': 'top',
};

const multiselectprops = {
    id: text('MultiSelect ID (id)', 'carbon-multiselect-example'),
    light: boolean('Light variant (light)', false),
    useTitleInItem: boolean('Show tooltip on hover', false),
    type: select('UI type (Only for `<MultiSelect>`) (type)', types, 'default'),
    size: select('Field size (size)', sizes, undefined) || undefined,
    direction: select('Dropdown direction (direction)', directions, 'bottom'),
    invalid: boolean('Show form validation UI (invalid)', false),
    invalidText: text(
        'Form validation UI content (invalidText)',
        'Invalid Selection'
    ),
    warn: boolean('Show warning state (warn)', false),
    warnText: text(
        'Warning state text (warnText)',
        'Selecting more items may increase processing time'
    ),
    listBoxMenuIconTranslationIds: object(
        'Listbox menu icon translation IDs (for translateWithId callback)',
        {
            'close.menu': 'Close menu',
            'open.menu': 'Open menu',
            'clear.all': 'Clear all',
            'clear.selection': 'Clear selection',
        }
    ),
    selectionFeedback: select(
        'Selection feedback',
        ['top', 'fixed', 'top-after-reopen'],
        'top-after-reopen'
    )
};

const HomeFilters = props => {

    const [filterSelections, setFilterSelections] = useState();
    const [disabledSelectsSAP, setDisabledSelectsSAP] = useState(props.filterSelectionsSAP.franchise && props.filterSelectionsSAP.franchise.length !== 0 ? false : true);
    const [disabledSelectsAutomation, setDisabledSelectsAutomation] = useState(props.filterSelectionsAutomation.franchise && props.filterSelectionsAutomation.franchise.length !== 0 ? false : true);
    const [disabledSelectsSalesforce, setDisabledSelectsSalesforce] = useState(props.filterSelectionsSalesforce.franchise && props.filterSelectionsSalesforce.franchise.length !== 0 ? false : true);
    const [clients, setClients] = useState(props.filterData && props.filterData.clients ? props.filterData.clients : []);
    const [franchiseItems, setFranchiseItems] = useState([]);
    const [showSelectedFranchise, setShowSelectedFranchise] = useState(false);
    const [clientKey, setClientKey] = useState(true);

    const franchise = i18n.t('filter.franchise');
    const Client = i18n.t('filter.Client');
    const Apply = i18n.t('filter.Apply');
    const [workspace, setWorkspace] = React.useState("");


    useEffect(() => {
        setWorkspace(props.workspace);
    }, [props.workspace]);

    useEffect(() => {
        if (workspace === workspaces.automation_ops) {
            setFilterSelections(props.filterSelectionsAutomation ? props.filterSelectionsAutomation : []);
            getClientData(props.filterSelectionsAutomation.franchise);
        }
        if (props.filterSelectionsAutomation && props.filterSelectionsAutomation.franchise && props.filterSelectionsAutomation.franchise.length !== 0) {
            setDisabledSelectsAutomation(false);
        }
    }, [props.workspace, props.filterSelectionsAutomation]);

    useEffect(() => {
        if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
            setFilterSelections(props.filterSelectionsSAP);
            getClientData(props.filterSelectionsSAP.franchise);
            getInfraFiltersData();
        }
        if (props.filterSelectionsSAP.franchise && props.filterSelectionsSAP.franchise.length !== 0) {
            setDisabledSelectsSAP(false);
        }

    }, [props.workspace, props.filterSelectionsSAP]);

    useEffect(() => {
        if (workspace === workspaces.salesforce_ops) {
            setFilterSelections(props.filterSelectionsSalesforce ? props.filterSelectionsSalesforce : []);
            getClientData(props.filterSelectionsSalesforce.franchise);
            //getSalesForceFiltersData();
        }
        if (props.filterSelectionsSalesforce.franchise && props.filterSelectionsSalesforce.franchise.length !== 0) {
            setDisabledSelectsSalesforce(false);
        }

    }, [props.workspace, props.filterSelectionsSalesforce]);

    useEffect(() => {
        if (showSelectedFranchise) {
            let selectedClientsList = [];
            selectedClientsList.push(clients.map((clientItem) => { return clientItem.name }));
            let selectedClients = filterSelections.client.filter(item => selectedClientsList[0].includes(item));
            setFilterSelections({ ...filterSelections, "client": selectedClients });
            setClientKey(!clientKey);
        }
    }, [clients])


    const getInfraFiltersData = () => {
        callPostApi(Constants.GETINFRAALERTSFILTERDATA, {
            'Content-Type': 'application/json'
        })
            .then(resp => {
                let franchiseList = [];
                if (resp && resp && resp.aggregations && resp.aggregations.franchises && resp.aggregations.franchises.buckets) {
                    resp.aggregations.franchises.buckets.forEach(element => {
                        let franchise = {};
                        franchise.name = element.key;
                        franchiseList.push(franchise);
                    });
                }
                if (props && props.filterData && props.filterData.franchises) {
                    franchiseList.push(...props.filterData.franchises);
                }
                const uniqueFranchiseNames = [...new Map(franchiseList.map(item => [JSON.stringify(item), item])).values()];
                //  console.log(franchiseList,uniqueFranchiseNames, "Franchisenames");
                setFranchiseItems(uniqueFranchiseNames);
            }, function (err) {
                console.trace(err.message);
            });

    }

    const handleFranchiseSelectionChange = (event) => {
        let franchiseLength = event.selectedItems.length;
        let oldFranchiseLength = filterSelections.franchise.length;
        if (oldFranchiseLength > franchiseLength) {
            setShowSelectedFranchise(true);
        }
        else  setShowSelectedFranchise(false);
        var selectedValues = event.selectedItems.map(function (k, v) {
            return k.name;
        });
        setFilterSelections({ ...filterSelections, "franchise": selectedValues });
        getClientData(selectedValues);

        if (selectedValues.length > 0) {
            if (props.workspace === workspaces.automation_ops) {
                setDisabledSelectsAutomation(false);
            }
            else if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
                setDisabledSelectsSAP(false);
            }
            else if (props.workspace === workspaces.salesforce_ops) {
                setDisabledSelectsSalesforce(false);
            }

        } else {
            let element = document.getElementById('client-select');
            element.firstChild.click();
            if (props.workspace === workspaces.automation_ops) {
                setDisabledSelectsAutomation(true);
            }
            else if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
                setDisabledSelectsSAP(true);
            }
            else if (props.workspace === workspaces.salesforce_ops) {
                setDisabledSelectsSalesforce(true);
            }
        }
    };

    const getClientData = (franchiseSelections) => {
        let request = {};
        let filtersArray = [];
        if (franchiseSelections != null && franchiseSelections.length > 0) {
            filtersArray = franchiseSelections;
        }
        request.alertType = props.alertType;
        request.filtersArray = filtersArray;

        if (props.workspace === workspaces.automation_ops) {
            request.automation = workspaces.automation_ops;
        }
        if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
            request.sap = workspaces.sap_ops;
        }
        if (props.workspace === workspaces.salesforce_ops) {
            request.salesforce = workspaces.salesforce_ops;
        }

        axios.all([
            callPostApi(Constants.GETCLIENTSURL, {
                'Content-Type': 'application/json'
            }, request).then(clientResponse => {
                if (clientResponse) {
                    return clientResponse;
                }
            }, function (err) {
                console.trace(err.message);
            }),
            //GETINFRAALERTSCLIENTSDATA to be called only in SAP space
            (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) &&
            callPostApi(Constants.GETINFRAALERTSCLIENTSDATA, {
                'Content-Type': 'application/json'
            }, request).then(franchiseResponse => {
                if (franchiseResponse) {
                    return franchiseResponse;
                }
            }, function (err) {
                console.trace(err.message);
            })

        ]).then(axios.spread((clientResponse, franchiseResponse) => {
            let clientsList = [];
            if (clientResponse && clientResponse.aggregations && clientResponse.aggregations.filtered && clientResponse.aggregations.filtered.clients.buckets) {
                clientResponse.aggregations.filtered.clients.buckets.forEach(element => {
                    let client = {};
                    client.name = element.key;
                    clientsList.push(client);
                });
            }
            if (franchiseResponse && franchiseResponse.aggregations && franchiseResponse.aggregations.filtered && franchiseResponse.aggregations.filtered.clients.buckets && props.workspace === workspaces.sap_ops) {
                franchiseResponse.aggregations.filtered.clients.buckets.forEach(element => {
                    let client = {};
                    client.name = element.key;
                    clientsList.push(client);
                });
            }
            const uniqueClientNames = [...new Map(clientsList.map(item => [JSON.stringify(item), item])).values()];
            //console.log(clientsList, uniqueClientNames, "ClientNames");
            (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) ? setClients(uniqueClientNames) : setClients(clientsList);
        }))
    }

    const handleSelectionChange = (type, event) => {
        var selectedValues = event.selectedItems.map(function (k, v) {
            return k.name;
        });
        switch (type) {
            case 'client-select':
                setFilterSelections({ ...filterSelections, "client": selectedValues });
                break;
            default:
        }
    };

    const handleFilterChange = () => {
        if (props.workspace === workspaces.automation_ops) {
            props.updateState('dashboardFilterSelectionsAutomation', filterSelections);
        }
        if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
            props.updateState('dashboardFilterSelectionsSAP', filterSelections);
        }
        if (props.workspace === workspaces.salesforce_ops) {
            props.updateState('dashboardFilterSelectionsSalesforce', filterSelections);
        }
        props.updateState('alertFilterData_clients', clients);
        //props.updateState('disabledSelects', disabledSelects);
        //props.handleClose();
    }

    const populateInitalSelectedItems = (selections) => {
        let initialValues = [];
        if (selections) {
            selections.map(function (v) {
                initialValues.push({ "name": v });
            });
        }
        return initialValues;
    }

    return (
        <div className="filter-selection">
            {workspace && filterSelections ?
                <div style={{ display: 'flex' }}>
                    <div className="multi-select-filter-alert">
                        <MultiSelect.Filterable
                            {...multiselectprops}
                            id='select'
                            helperText=''
                            disabled={false}
                            label={franchise}
                            placeholder={franchise}
                            items={workspace === workspaces.automation_ops ?
                                props.filterData && props.filterData.franchises ? props.filterData.franchises : []
                                : workspace === workspaces.salesforce_ops ? props.filterData && props.filterData.franchises ? props.filterData.franchises : [] 
                                : franchiseItems ? franchiseItems : []
                            }
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItems={populateInitalSelectedItems(filterSelections.franchise)}
                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                            selectionFeedback={multiselectprops.selectionFeedback}
                            onChange={handleFranchiseSelectionChange}
                        // placeholder={franchise}
                        />
                    </div>
                    <div className="multi-select-filter-alert">
                        <MultiSelect.Filterable
                            {...multiselectprops}
                            id='client-select'
                            key={clientKey}
                            helperText=''
                            disabled={workspace === workspaces.automation_ops ? disabledSelectsAutomation : workspace === workspaces.salesforce_ops ? disabledSelectsSalesforce : disabledSelectsSAP}
                            label={Client}
                            placeholder={Client}
                            items={clients ? clients : []}
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItems={populateInitalSelectedItems(filterSelections.client)}
                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                            selectionFeedback={multiselectprops.selectionFeedback}
                            onChange={(e) => handleSelectionChange('client-select', e)}
                        // placeholder={Client}
                        />
                    </div>
                    <Button kind='primary' onClick={handleFilterChange}>
                        {Apply}
                    </Button></div>
                : null}

        </div>

    );
};
export default HomeFilters;
